// https://github.com/devindex/vue-mask
import VueMask from "@devindex/vue-mask";
export default function (app) {
  app.use(VueMask);
}
